import { Theme, makeStyles } from '@material-ui/core';

const styles = makeStyles((theme: Theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  tableHeaderCell: {
    backgroundColor: '#FAFAFA',
    fontSize: theme.spacing(1.75),
    fontWeight: 'bold',
    lineHeight: '24px',
    paddingLeft: theme.spacing(1.25),
    paddingBottom: theme.spacing(0.5),
    paddingTop: theme.spacing(0.5),
  },
  tableCell: {
    padding: theme.spacing(1),
    borderColor: 'transparent',
  },
  roundedBox: {
    backgroundColor: 'white',
    width: '49%',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1.25),
    paddingRight: theme.spacing(2.5),
  },
  attributeInformationRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2.5),
  },
  controlWithTitle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing(1.25),
    marginBottom: theme.spacing(1.25),
    alignItems: 'center',
  },
  buttonStyle: {
    backgroundColor: 'transparent',
    border: '1px solid rgba(0, 0, 0, 0.87)',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 'bold',
  },
  buttonStyleBlack: {
    backgroundColor: 'black',
    border: '1px solid rgba(0, 0, 0, 0.87)',
    color: 'white',
    fontWeight: 'bold',
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
      border: '1px solid rgba(0, 0, 0, 0.12)',
      backgroundColor: '#e3e5e6',
    },
  },
  root: {
    backgroundColor: theme.palette.grey[100],
    padding: '20px 74px',
  },
  cardTitle: {
    fontSize: theme.spacing(2),
    fontWeight: 'bold',
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  headerTitle: {
    fontSize: theme.spacing(2.75),
    fontWeight: 'bold',
    lineHeight: '32.02px',
  },
  subtext: {
    color: 'rgba(0, 0, 0, 0.6)',
  },
  headerSubtitle: {
    fontSize: theme.spacing(1.75),
    fontWeight: 'lighter',
    lineHeight: '20.02px',
  },
  cardSubtitle: {
    fontSize: theme.spacing(1.5),
    lineHeight: '19.92px',
    letterSpacing: '0.4px',
    height: 'auto',
    display: 'inline',
  },
  dialog: {},
  attributeField: {
    backgroundColor: 'white',
    width: '49%',
  },
  switch: {
    '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#2E7D32',
    },
    '& .MuiSwitch-colorSecondary.Mui-checked': {
      color: '#2E7D32',
    },
  },
  tableField: {
    backgroundColor: 'white',
  },
  switchWithLabel: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  card: {
    justifyContent: 'center',
    borderRadius: theme.spacing(0.4),
    borderColor: 'rgba(0, 0, 0, 0.20)',
    borderStyle: 'solid',
    borderWidth: theme.spacing(0.1),
    backgroundColor: 'white',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  chips: {
    padding: '0',
    paddingTop: '0',
  },
  helperProps: {
    fontWeight: 'lighter',
    fontSize: theme.spacing(1.75),
    backgroundColor: 'white',
    padding: '0',
    marginLeft: '0',
  },
  tableHeaderCaption: {
    paddingLeft: theme.spacing(1),
    color: theme.palette.grey[700],
  },
}));

export default styles;
